

































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Card } from '@alpha/ink'
import StartedImg from '@/assets/img/illustrations/getting-started.png'
import StartedColorImg from '@/assets/img/illustrations/getting-started-color.png'
import HowImg from '@/assets/img/illustrations/how.png'
import HowImgColor from '@/assets/img/illustrations/how-color.png'
import FaqImg from '@/assets/img/illustrations/faq.png'
import FaqImgColor from '@/assets/img/illustrations/faq-color.png'

@Component({
  components: { Card }
})

export default class ResourceSection extends Vue {
  @Prop({ default: true }) showHeader!:boolean

  get resources () {
    return [
      {
        icon: StartedImg,
        greyImg: StartedImg,
        colorImg: StartedColorImg,
        title: 'Getting Started',
        url: 'https://help.alphahq.com/en/collections/1648828-getting-started',
        description: 'Resources to get you started testing'
      },
      {
        icon: HowImg,
        greyImg: HowImg,
        colorImg: HowImgColor,
        title: 'How to Use Feedback Loop',
        url: 'https://help.alphahq.com/en',
        description: 'Step by step instructions and platform features'
      },
      {
        icon: FaqImg,
        greyImg: FaqImg,
        colorImg: FaqImgColor,
        title: 'Feedback Loop FAQ',
        url: 'https://help.alphahq.com/en/collections/1672812-experimentation-and-alpha-faq',
        description: 'Experimentation and Methodology'
      }
    ]
  }
}
